var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.190002,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#B22539",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5249 58.6L60.5249 48.6V58.6H50.5249ZM60.5249 28.6L50.5249 18.6H60.5249V28.6ZM30.5249 18.6L20.5249 28.6V18.6H30.5249ZM20.5249 48.6L30.5249 58.6H20.5249V48.6ZM52.8999 50.975C46.0749 57.8 34.9749 57.8 28.1499 50.975C21.3249 44.15 21.3249 33.05 28.1499 26.225C34.9749 19.4 46.0749 19.4 52.8999 26.225C59.7249 33.05 59.7249 44.125 52.8999 50.975ZM50.1499 28.975C44.8249 23.65 36.2249 23.65 30.8999 28.975C25.5749 34.3 25.5749 42.9 30.8999 48.225C36.2249 53.55 44.8249 53.55 50.1499 48.225C55.4749 42.9 55.4749 34.3 50.1499 28.975Z",
    fill: "#B22539"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy2);
export default __webpack_public_path__ + "static/media/why2.eee89a784721869a334b4b30dd017c75.svg";
export { ForwardRef as ReactComponent };